import React, { useState } from 'react';
import { ModalBody, ModalFooter, Modal, Button } from 'reactstrap';

export const ModalClickable = ({ header, color, url }) => {
  // Preparamos las variables necesarias
  const [modalState, setModalState] = useState(true);

  // Función que controla el estado de la modal
  const handleModalState = () => {
    if (modalState) {
      setModalState(false);
      window.location.href = url;
    } else {
      setModalState(true);
    }
  };

  return (
    <Modal isOpen={modalState} centered>
      <ModalBody>
        <h4 className="text-center mt-3">{header}</h4>
      </ModalBody>
      <ModalFooter>
        <Button color={color || 'danger'} onClick={handleModalState}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
